import { render } from "./MigrateWizard.vue?vue&type=template&id=a6ec01fe&scoped=true"
import script from "./MigrateWizard.vue?vue&type=script&lang=js"
export * from "./MigrateWizard.vue?vue&type=script&lang=js"

import "./MigrateWizard.vue?vue&type=style&index=0&id=a6ec01fe&scoped=true&lang=scss"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6ec01fe"]])

export default __exports__